module.exports = __webpack_public_path__ + "static/media/right@2x.27b24e42.svg";